// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__tz-F1","inputWrap":"Table_inputWrap__zAw16","col":"Table_col__19hXn","bmiTooltip":"Table_bmiTooltip__2UpoH"};